import { render, staticRenderFns } from "./RequestRatingsTable.vue?vue&type=template&id=56c0c225"
import script from "./RequestRatingsTable.vue?vue&type=script&lang=js"
export * from "./RequestRatingsTable.vue?vue&type=script&lang=js"
import style0 from "./RequestRatingsTable.vue?vue&type=style&index=0&id=56c0c225&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports